import { handleActions } from 'redux-actions'
import {
  getApartmentAvailability,
  getApartmentAvailabilitySuccess,
  getApartmentAvailabilityFail,
  getApartmentAvailabilitiesByApplicants,
  getApartmentAvailabilitiesByApplicantsSuccess,
  getApartmentAvailabilitiesByApplicantsFail,
  createApplicantAvailabilityFail,
  createApplicantAvailabilitySuccess,
  createApplicantAvailability,
  deleteApplicantAvailability,
  deleteApplicantAvailabilityFail,
  deleteApplicantAvailabilitySuccess
} from '../actions/applicantAvailability'
import { ApplicantAvailabilitiesState } from '../types/states'
import { Action, ActionWithPayload } from './types'

const initialState: ApplicantAvailabilitiesState = {
  isCreating: false,
  isDeleting: false,
  availabilities: [],
  availabilitiesByApplicants: []
}

const availabilitiesReducer = handleActions(
  {
    [createApplicantAvailability]: (state) => ({
      ...state,
      isCreating: true
    }),
    [createApplicantAvailabilitySuccess]: (
      state,
      { payload: availabilityItem }: Action<any>
    ) => ({
      ...state,
      availabilitiesByApplicants: [
        ...state.availabilitiesByApplicants,
        availabilityItem
      ],
      isCreating: false
    }),
    [createApplicantAvailabilityFail]: (state) => ({
      ...state,
      isCreating: false
    }),
    [deleteApplicantAvailability]: (state) => ({
      ...state,
      isDeleting: true
    }),
    [deleteApplicantAvailabilitySuccess]: (state) => ({
      ...state,
      isDeleting: false
    }),
    [deleteApplicantAvailabilityFail]: (state) => ({
      ...state,
      isDeleting: false
    }),
    [getApartmentAvailability]: (state) => ({
      ...state
    }),
    [getApartmentAvailabilityFail]: (state) => ({
      ...state
    }),
    [getApartmentAvailabilitySuccess]: (
      state: ApplicantAvailabilitiesState,
      { payload: availabilities }: ActionWithPayload<any>
    ) => ({
      ...state,
      availabilities
    }),
    [getApartmentAvailabilitiesByApplicants]: (state) => ({
      ...state
    }),
    [getApartmentAvailabilitiesByApplicantsFail]: (state) => ({
      ...state
    }),
    [getApartmentAvailabilitiesByApplicantsSuccess]: (
      state,
      { payload: availability }: ActionWithPayload<any>
    ) => ({
      ...state,
      availabilitiesByApplicants: availability
    })
  },
  initialState
)

export default availabilitiesReducer
